<template>
  <svg width="148" height="139" viewBox="0 0 148 139" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M2.31284 139C3.58999 139 4.62532 137.922 4.62532 136.593C4.62532 135.263 3.58999 134.186 2.31284 134.186C1.0357 134.186 0.000366211 135.263 0.000366211 136.593C0.000366211 137.922 1.0357 139 2.31284 139Z"
      fill="currentColor"
    />
    <path
      d="M43.9381 139C45.2152 139 46.2506 137.922 46.2506 136.593C46.2506 135.263 45.2152 134.185 43.9381 134.185C42.6609 134.185 41.6256 135.263 41.6256 136.593C41.6256 137.922 42.6609 139 43.9381 139Z"
      fill="currentColor"
    />
    <path
      d="M23.1246 139C24.4018 139 25.4371 137.922 25.4371 136.593C25.4371 135.263 24.4018 134.185 23.1246 134.185C21.8475 134.185 20.8121 135.263 20.8121 136.593C20.8121 137.922 21.8475 139 23.1246 139Z"
      fill="currentColor"
    />
    <path
      d="M63.5936 139C64.8707 139 65.9061 137.922 65.9061 136.593C65.9061 135.263 64.8707 134.185 63.5936 134.185C62.3165 134.185 61.2811 135.263 61.2811 136.593C61.2811 137.922 62.3165 139 63.5936 139Z"
      fill="currentColor"
    />
    <path
      d="M84.4054 139C85.6825 139 86.7178 137.922 86.7178 136.593C86.7178 135.263 85.6825 134.185 84.4054 134.185C83.1282 134.185 82.0929 135.263 82.0929 136.593C82.0929 137.922 83.1282 139 84.4054 139Z"
      fill="currentColor"
    />
    <path
      d="M105.218 139C106.495 139 107.53 137.922 107.53 136.593C107.53 135.263 106.495 134.185 105.218 134.185C103.941 134.185 102.906 135.263 102.906 136.593C102.906 137.922 103.941 139 105.218 139Z"
      fill="currentColor"
    />
    <path
      d="M124.874 139C126.151 139 127.186 137.922 127.186 136.593C127.186 135.263 126.151 134.185 124.874 134.185C123.597 134.185 122.562 135.263 122.562 136.593C122.562 137.922 123.597 139 124.874 139Z"
      fill="currentColor"
    />
    <path
      d="M145.686 139C146.963 139 147.999 137.922 147.999 136.593C147.999 135.263 146.963 134.185 145.686 134.185C144.409 134.185 143.374 135.263 143.374 136.593C143.374 137.922 144.409 139 145.686 139Z"
      fill="currentColor"
    />
    <path
      d="M2.31443 5.76404C3.59157 5.76404 4.6269 4.68629 4.6269 3.35681C4.6269 2.02734 3.59157 0.949585 2.31443 0.949585C1.03728 0.949585 0.00195312 2.02734 0.00195312 3.35681C0.00195312 4.68629 1.03728 5.76404 2.31443 5.76404Z"
      fill="currentColor"
    />
    <path
      d="M43.9393 5.76404C45.2165 5.76404 46.2518 4.68629 46.2518 3.35681C46.2518 2.02734 45.2165 0.949585 43.9393 0.949585C42.6622 0.949585 41.6268 2.02734 41.6268 3.35681C41.6268 4.68629 42.6622 5.76404 43.9393 5.76404Z"
      fill="currentColor"
    />
    <path
      d="M23.1267 5.76404C24.4038 5.76404 25.4392 4.68629 25.4392 3.35681C25.4392 2.02734 24.4038 0.949585 23.1267 0.949585C21.8495 0.949585 20.8142 2.02734 20.8142 3.35681C20.8142 4.68629 21.8495 5.76404 23.1267 5.76404Z"
      fill="currentColor"
    />
    <path
      d="M63.5952 5.76404C64.8723 5.76404 65.9077 4.68629 65.9077 3.35681C65.9077 2.02734 64.8723 0.949585 63.5952 0.949585C62.318 0.949585 61.2827 2.02734 61.2827 3.35681C61.2827 4.68629 62.318 5.76404 63.5952 5.76404Z"
      fill="currentColor"
    />
    <path
      d="M84.4062 5.76404C85.6834 5.76404 86.7187 4.68629 86.7187 3.35681C86.7187 2.02734 85.6834 0.949585 84.4062 0.949585C83.1291 0.949585 82.0938 2.02734 82.0938 3.35681C82.0938 4.68629 83.1291 5.76404 84.4062 5.76404Z"
      fill="currentColor"
    />
    <path
      d="M105.219 5.76404C106.496 5.76404 107.531 4.68629 107.531 3.35681C107.531 2.02734 106.496 0.949585 105.219 0.949585C103.942 0.949585 102.906 2.02734 102.906 3.35681C102.906 4.68629 103.942 5.76404 105.219 5.76404Z"
      fill="currentColor"
    />
    <path
      d="M124.875 5.76404C126.152 5.76404 127.188 4.68629 127.188 3.35681C127.188 2.02734 126.152 0.949585 124.875 0.949585C123.598 0.949585 122.563 2.02734 122.563 3.35681C122.563 4.68629 123.598 5.76404 124.875 5.76404Z"
      fill="currentColor"
    />
    <path
      d="M145.688 5.76404C146.965 5.76404 148 4.68629 148 3.35681C148 2.02734 146.965 0.949585 145.688 0.949585C144.411 0.949585 143.375 2.02734 143.375 3.35681C143.375 4.68629 144.411 5.76404 145.688 5.76404Z"
      fill="currentColor"
    />
    <path
      d="M2.31443 27.4288C3.59157 27.4288 4.6269 26.3511 4.6269 25.0216C4.6269 23.6921 3.59157 22.6144 2.31443 22.6144C1.03728 22.6144 0.00195312 23.6921 0.00195312 25.0216C0.00195312 26.3511 1.03728 27.4288 2.31443 27.4288Z"
      fill="currentColor"
    />
    <path
      d="M43.9393 27.4288C45.2165 27.4288 46.2518 26.3511 46.2518 25.0216C46.2518 23.6921 45.2165 22.6144 43.9393 22.6144C42.6622 22.6144 41.6268 23.6921 41.6268 25.0216C41.6268 26.3511 42.6622 27.4288 43.9393 27.4288Z"
      fill="currentColor"
    />
    <path
      d="M23.1267 27.4288C24.4038 27.4288 25.4392 26.3511 25.4392 25.0216C25.4392 23.6921 24.4038 22.6144 23.1267 22.6144C21.8495 22.6144 20.8142 23.6921 20.8142 25.0216C20.8142 26.3511 21.8495 27.4288 23.1267 27.4288Z"
      fill="currentColor"
    />
    <path
      d="M63.5952 27.4288C64.8723 27.4288 65.9077 26.3511 65.9077 25.0216C65.9077 23.6921 64.8723 22.6144 63.5952 22.6144C62.318 22.6144 61.2827 23.6921 61.2827 25.0216C61.2827 26.3511 62.318 27.4288 63.5952 27.4288Z"
      fill="currentColor"
    />
    <path
      d="M84.4062 27.4288C85.6834 27.4288 86.7187 26.3511 86.7187 25.0216C86.7187 23.6921 85.6834 22.6144 84.4062 22.6144C83.1291 22.6144 82.0938 23.6921 82.0938 25.0216C82.0938 26.3511 83.1291 27.4288 84.4062 27.4288Z"
      fill="currentColor"
    />
    <path
      d="M105.219 27.4288C106.496 27.4288 107.531 26.3511 107.531 25.0216C107.531 23.6921 106.496 22.6144 105.219 22.6144C103.942 22.6144 102.906 23.6921 102.906 25.0216C102.906 26.3511 103.942 27.4288 105.219 27.4288Z"
      fill="currentColor"
    />
    <path
      d="M124.875 27.4288C126.152 27.4288 127.188 26.3511 127.188 25.0216C127.188 23.6921 126.152 22.6144 124.875 22.6144C123.598 22.6144 122.563 23.6921 122.563 25.0216C122.563 26.3511 123.598 27.4288 124.875 27.4288Z"
      fill="currentColor"
    />
    <path
      d="M145.688 27.4288C146.965 27.4288 148 26.3511 148 25.0216C148 23.6921 146.965 22.6144 145.688 22.6144C144.411 22.6144 143.375 23.6921 143.375 25.0216C143.375 26.3511 144.411 27.4288 145.688 27.4288Z"
      fill="currentColor"
    />
    <path
      d="M2.31443 50.297C3.59157 50.297 4.6269 49.2192 4.6269 47.8898C4.6269 46.5603 3.59157 45.4825 2.31443 45.4825C1.03728 45.4825 0.00195312 46.5603 0.00195312 47.8898C0.00195312 49.2192 1.03728 50.297 2.31443 50.297Z"
      fill="currentColor"
    />
    <path
      d="M43.9393 50.297C45.2165 50.297 46.2518 49.2192 46.2518 47.8898C46.2518 46.5603 45.2165 45.4825 43.9393 45.4825C42.6622 45.4825 41.6268 46.5603 41.6268 47.8898C41.6268 49.2192 42.6622 50.297 43.9393 50.297Z"
      fill="currentColor"
    />
    <path
      d="M23.1267 50.297C24.4038 50.297 25.4392 49.2192 25.4392 47.8898C25.4392 46.5603 24.4038 45.4825 23.1267 45.4825C21.8495 45.4825 20.8142 46.5603 20.8142 47.8898C20.8142 49.2192 21.8495 50.297 23.1267 50.297Z"
      fill="currentColor"
    />
    <path
      d="M63.5952 50.297C64.8723 50.297 65.9077 49.2192 65.9077 47.8898C65.9077 46.5603 64.8723 45.4825 63.5952 45.4825C62.318 45.4825 61.2827 46.5603 61.2827 47.8898C61.2827 49.2192 62.318 50.297 63.5952 50.297Z"
      fill="currentColor"
    />
    <path
      d="M84.4062 50.297C85.6834 50.297 86.7187 49.2192 86.7187 47.8898C86.7187 46.5603 85.6834 45.4825 84.4062 45.4825C83.1291 45.4825 82.0938 46.5603 82.0938 47.8898C82.0938 49.2192 83.1291 50.297 84.4062 50.297Z"
      fill="currentColor"
    />
    <path
      d="M105.219 50.297C106.496 50.297 107.531 49.2192 107.531 47.8898C107.531 46.5603 106.496 45.4825 105.219 45.4825C103.942 45.4825 102.906 46.5603 102.906 47.8898C102.906 49.2192 103.942 50.297 105.219 50.297Z"
      fill="currentColor"
    />
    <path
      d="M124.875 50.297C126.152 50.297 127.188 49.2192 127.188 47.8898C127.188 46.5603 126.152 45.4825 124.875 45.4825C123.598 45.4825 122.563 46.5603 122.563 47.8898C122.563 49.2192 123.598 50.297 124.875 50.297Z"
      fill="currentColor"
    />
    <path
      d="M145.688 50.297C146.965 50.297 148 49.2192 148 47.8898C148 46.5603 146.965 45.4825 145.688 45.4825C144.411 45.4825 143.375 46.5603 143.375 47.8898C143.375 49.2192 144.411 50.297 145.688 50.297Z"
      fill="currentColor"
    />
    <path
      d="M2.31443 71.9623C3.59157 71.9623 4.6269 70.8845 4.6269 69.5551C4.6269 68.2256 3.59157 67.1478 2.31443 67.1478C1.03728 67.1478 0.00195312 68.2256 0.00195312 69.5551C0.00195312 70.8845 1.03728 71.9623 2.31443 71.9623Z"
      fill="currentColor"
    />
    <path
      d="M43.9393 71.9623C45.2165 71.9623 46.2518 70.8845 46.2518 69.5551C46.2518 68.2256 45.2165 67.1478 43.9393 67.1478C42.6622 67.1478 41.6268 68.2256 41.6268 69.5551C41.6268 70.8845 42.6622 71.9623 43.9393 71.9623Z"
      fill="currentColor"
    />
    <path
      d="M23.1267 71.9623C24.4038 71.9623 25.4392 70.8845 25.4392 69.5551C25.4392 68.2256 24.4038 67.1478 23.1267 67.1478C21.8495 67.1478 20.8142 68.2256 20.8142 69.5551C20.8142 70.8845 21.8495 71.9623 23.1267 71.9623Z"
      fill="currentColor"
    />
    <path
      d="M63.5952 71.9623C64.8723 71.9623 65.9077 70.8845 65.9077 69.5551C65.9077 68.2256 64.8723 67.1478 63.5952 67.1478C62.318 67.1478 61.2827 68.2256 61.2827 69.5551C61.2827 70.8845 62.318 71.9623 63.5952 71.9623Z"
      fill="currentColor"
    />
    <path
      d="M84.4062 71.9623C85.6834 71.9623 86.7187 70.8845 86.7187 69.5551C86.7187 68.2256 85.6834 67.1478 84.4062 67.1478C83.1291 67.1478 82.0938 68.2256 82.0938 69.5551C82.0938 70.8845 83.1291 71.9623 84.4062 71.9623Z"
      fill="currentColor"
    />
    <path
      d="M105.219 71.9623C106.496 71.9623 107.531 70.8845 107.531 69.5551C107.531 68.2256 106.496 67.1478 105.219 67.1478C103.942 67.1478 102.906 68.2256 102.906 69.5551C102.906 70.8845 103.942 71.9623 105.219 71.9623Z"
      fill="currentColor"
    />
    <path
      d="M124.875 71.9623C126.152 71.9623 127.188 70.8845 127.188 69.5551C127.188 68.2256 126.152 67.1478 124.875 67.1478C123.598 67.1478 122.563 68.2256 122.563 69.5551C122.563 70.8845 123.598 71.9623 124.875 71.9623Z"
      fill="currentColor"
    />
    <path
      d="M145.688 71.9623C146.965 71.9623 148 70.8845 148 69.5551C148 68.2256 146.965 67.1478 145.688 67.1478C144.411 67.1478 143.375 68.2256 143.375 69.5551C143.375 70.8845 144.411 71.9623 145.688 71.9623Z"
      fill="currentColor"
    />
    <path
      d="M2.31443 94.8309C3.59157 94.8309 4.6269 93.7532 4.6269 92.4237C4.6269 91.0942 3.59157 90.0165 2.31443 90.0165C1.03728 90.0165 0.00195312 91.0942 0.00195312 92.4237C0.00195312 93.7532 1.03728 94.8309 2.31443 94.8309Z"
      fill="currentColor"
    />
    <path
      d="M43.9393 94.8309C45.2165 94.8309 46.2518 93.7532 46.2518 92.4237C46.2518 91.0942 45.2165 90.0165 43.9393 90.0165C42.6622 90.0165 41.6268 91.0942 41.6268 92.4237C41.6268 93.7532 42.6622 94.8309 43.9393 94.8309Z"
      fill="currentColor"
    />
    <path
      d="M23.1267 94.8309C24.4038 94.8309 25.4392 93.7532 25.4392 92.4237C25.4392 91.0942 24.4038 90.0165 23.1267 90.0165C21.8495 90.0165 20.8142 91.0942 20.8142 92.4237C20.8142 93.7532 21.8495 94.8309 23.1267 94.8309Z"
      fill="currentColor"
    />
    <path
      d="M63.5952 94.8309C64.8723 94.8309 65.9077 93.7532 65.9077 92.4237C65.9077 91.0942 64.8723 90.0165 63.5952 90.0165C62.318 90.0165 61.2827 91.0942 61.2827 92.4237C61.2827 93.7532 62.318 94.8309 63.5952 94.8309Z"
      fill="currentColor"
    />
    <path
      d="M84.4062 94.8309C85.6834 94.8309 86.7187 93.7532 86.7187 92.4237C86.7187 91.0942 85.6834 90.0165 84.4062 90.0165C83.1291 90.0165 82.0938 91.0942 82.0938 92.4237C82.0938 93.7532 83.1291 94.8309 84.4062 94.8309Z"
      fill="currentColor"
    />
    <path
      d="M105.219 94.8309C106.496 94.8309 107.531 93.7532 107.531 92.4237C107.531 91.0942 106.496 90.0165 105.219 90.0165C103.942 90.0165 102.906 91.0942 102.906 92.4237C102.906 93.7532 103.942 94.8309 105.219 94.8309Z"
      fill="currentColor"
    />
    <path
      d="M124.875 94.8309C126.152 94.8309 127.188 93.7532 127.188 92.4237C127.188 91.0942 126.152 90.0165 124.875 90.0165C123.598 90.0165 122.563 91.0942 122.563 92.4237C122.563 93.7532 123.598 94.8309 124.875 94.8309Z"
      fill="currentColor"
    />
    <path
      d="M145.688 94.8309C146.965 94.8309 148 93.7532 148 92.4237C148 91.0942 146.965 90.0165 145.688 90.0165C144.411 90.0165 143.375 91.0942 143.375 92.4237C143.375 93.7532 144.411 94.8309 145.688 94.8309Z"
      fill="currentColor"
    />
    <path
      d="M2.31443 116.496C3.59157 116.496 4.6269 115.419 4.6269 114.089C4.6269 112.76 3.59157 111.682 2.31443 111.682C1.03728 111.682 0.00195312 112.76 0.00195312 114.089C0.00195312 115.419 1.03728 116.496 2.31443 116.496Z"
      fill="currentColor"
    />
    <path
      d="M43.9393 116.496C45.2165 116.496 46.2518 115.419 46.2518 114.089C46.2518 112.76 45.2165 111.682 43.9393 111.682C42.6622 111.682 41.6268 112.76 41.6268 114.089C41.6268 115.419 42.6622 116.496 43.9393 116.496Z"
      fill="currentColor"
    />
    <path
      d="M23.1267 116.496C24.4038 116.496 25.4392 115.419 25.4392 114.089C25.4392 112.76 24.4038 111.682 23.1267 111.682C21.8495 111.682 20.8142 112.76 20.8142 114.089C20.8142 115.419 21.8495 116.496 23.1267 116.496Z"
      fill="currentColor"
    />
    <path
      d="M63.5952 116.496C64.8723 116.496 65.9077 115.419 65.9077 114.089C65.9077 112.76 64.8723 111.682 63.5952 111.682C62.318 111.682 61.2827 112.76 61.2827 114.089C61.2827 115.419 62.318 116.496 63.5952 116.496Z"
      fill="currentColor"
    />
    <path
      d="M84.4062 116.496C85.6834 116.496 86.7187 115.419 86.7187 114.089C86.7187 112.76 85.6834 111.682 84.4062 111.682C83.1291 111.682 82.0938 112.76 82.0938 114.089C82.0938 115.419 83.1291 116.496 84.4062 116.496Z"
      fill="currentColor"
    />
    <path
      d="M105.219 116.496C106.496 116.496 107.531 115.419 107.531 114.089C107.531 112.76 106.496 111.682 105.219 111.682C103.942 111.682 102.906 112.76 102.906 114.089C102.906 115.419 103.942 116.496 105.219 116.496Z"
      fill="currentColor"
    />
    <path
      d="M124.875 116.496C126.152 116.496 127.188 115.419 127.188 114.089C127.188 112.76 126.152 111.682 124.875 111.682C123.598 111.682 122.563 112.76 122.563 114.089C122.563 115.419 123.598 116.496 124.875 116.496Z"
      fill="currentColor"
    />
    <path
      d="M145.688 116.496C146.965 116.496 148 115.419 148 114.089C148 112.76 146.965 111.682 145.688 111.682C144.411 111.682 143.375 112.76 143.375 114.089C143.375 115.419 144.411 116.496 145.688 116.496Z"
      fill="currentColor"
    />
  </svg>
</template>
